import {mediaSourceUrl, MediaSourceInput, resolveAudioSource, resolveVideoSource} from '../media/MediaPlayer';
import {CourseMediaAssets} from './CourseMediaAssetsContext';

interface UnitMediaSummaryInput {
  posterUrl?: string;
  coverUrl?: string;
  videoUrl?: string;
  audioUrl?: string;
  externalVideoUrl?: string;
  poster?: MediaSourceInput;
  cover?: MediaSourceInput;
  video?: MediaSourceInput;
  audio?: MediaSourceInput;
}

function imageUrl(input: MediaSourceInput): string {
  const url = mediaSourceUrl(input);
  return /\/missing\./i.test(url.split(/[?#]/)[0]) ? '' : url;
}

export function unitMediaSummary(unit: UnitMediaSummaryInput, assets: CourseMediaAssets) {
  const video = [unit.videoUrl, unit.video, unit.externalVideoUrl]
    .map(resolveVideoSource).find(source => source.kind !== 'none');
  const audio = [unit.audioUrl, unit.audio]
    .map(resolveAudioSource).find(source => source.kind !== 'none');
  const poster = imageUrl(unit.posterUrl) || imageUrl(unit.poster);
  const cover = imageUrl(unit.coverUrl) || imageUrl(unit.cover);
  const badges: string[] = [];
  if (video) badges.push(video.kind === 'hls' ? 'HLS' : video.kind === 'vimeo-embed' ? 'Vimeo' : 'Vídeo');
  if (audio) badges.push('Áudio');
  if (!video && !audio && (poster || cover)) badges.push('Imagem');
  if (!badges.length) badges.push('Sem mídia');
  const thumbnail = !video && audio
    ? assets.audioCover || poster || cover || assets.posterPlaceholder
    : poster || cover || assets.posterPlaceholder;
  return {badges, thumbnail};
}
